import { IPaymentTermData } from "common/records/PaymentTerm";
import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";

export const RECEIVE_PAYMENT_TERMS = "@paymentTerms/RECEIVE_PAYMENT_TERMS";
export const RECEIVE_PAYMENT_TERM = "@paymentTerms/RECEIVE_PAYMENT_TERM";
export const REMOVE_PAYMENT_TERM = "@paymentTerms/REMOVE_PAYMENT_TERM";
export const RESET_PAYMENT_TERM = "@paymentTerms/RESET_PAYMENT_TERM";
export const ADD_BREAKDOWN_ITEM = "@paymentTerms/ADD_BREAKDOWN_ITEM";
export const REMOVE_BREAKDOWN_ITEM = "@paymentTerms/REMOVE_BREAKDOWN_ITEM";

export const PaymentTermActions = {
  receivePaymentTerm: (paymentTerm: Partial<IPaymentTermData>) => createAction(RECEIVE_PAYMENT_TERM, paymentTerm),
  receivePaymentTerms: (paymentTerms: Partial<IPaymentTermData>[]) =>
    createAction(RECEIVE_PAYMENT_TERMS, { paymentTerms }),
  removePaymentTerm: (paymentTermId: number) => createAction(REMOVE_PAYMENT_TERM, paymentTermId),
  resetPaymentTerm: (paymentTermId: number) => createAction(RESET_PAYMENT_TERM, paymentTermId),
  addBreakdownItem: (paymentTermId: number) => createAction(ADD_BREAKDOWN_ITEM, paymentTermId),
  removeBreakdownItem: (paymentTermId: number, itemIndex: number) =>
    createAction(REMOVE_BREAKDOWN_ITEM, { paymentTermId, itemIndex }),
};

export type PaymentTermActions = ActionsUnion<typeof PaymentTermActions>;
